import { render, staticRenderFns } from "./allocation_tiers.vue?vue&type=template&id=06edf16c&scoped=true&"
import script from "./allocation_tiers.vue?vue&type=script&lang=js&"
export * from "./allocation_tiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06edf16c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06edf16c')) {
      api.createRecord('06edf16c', component.options)
    } else {
      api.reload('06edf16c', component.options)
    }
    module.hot.accept("./allocation_tiers.vue?vue&type=template&id=06edf16c&scoped=true&", function () {
      api.rerender('06edf16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allocation_configs/partials/allocation_tiers.vue"
export default component.exports